import tickets_img from '../imgs/category_imgs/tickets.png';
import clothing_img from '../imgs/category_imgs/clothing.png';
import electronics_img from '../imgs/category_imgs/electronics.jpg';
import collectibles_img from '../imgs/category_imgs/collectibles.png';
import furniture_img from '../imgs/category_imgs/furniture.jpg';
import vehicles_img from '../imgs/category_imgs/vehicles.jpg';
import auto_parts_img from '../imgs/category_imgs/auto-parts.jpg';
import school_supplies_img from '../imgs/category_imgs/school-supplies.png';
import art_supplies_img from '../imgs/category_imgs/art-supplies.jpg';
import entertainment_img from '../imgs/category_imgs/entertainment.jpg';
import health_wellness_img from '../imgs/category_imgs/health-wellness.png';
import baby_kids_img from '../imgs/category_imgs/baby-kids.png';
import personal_care_img from '../imgs/category_imgs/personal-care.jpg';
import beauty_img from '../imgs/category_imgs/beauty.jpg';
import pets_img from '../imgs/category_imgs/pets.jpg';
import sports_img from '../imgs/category_imgs/sports.jpg';
import gardening_img from '../imgs/category_imgs/gardening.jpg';
import lawn_care_img from '../imgs/category_imgs/lawn-care.jpg';
import seasonal_img from '../imgs/category_imgs/seasonal.jpg';

export const CATEGORY_LIST = [
    // lease takeover
    {
        _id: "lease-takeover",
        parent_id: ["housing"],
        order_num: 1,
        url_handle: "lease-takeover",
        name: "Lease Takeover",
        search_tags: ["lease takeover", "lease"],
        img: null,
    },
    // tickets
    {
        _id: "tickets",
        parent_id: null,
        featured: true,
        order_num: 1,
        url_handle: "tickets",
        name: "Tickets",
        search_tags: ["tickets", "concert tickets", "college football tickets", "football tickets", "basketball tickets", "hockey tickets", "tennis tickets"],
        img: tickets_img,
    },
    {
        _id: "concert-tickets",
        parent_id: ["tickets"],
        order_num: 1,
        url_handle: "concert-tickets",
        name: "Concerts",
        search_tags: ["concert tickets"],
        img: null,
    },
    {
        _id: "college-football-tickets",
        parent_id: ["tickets"],
        order_num: 2,
        url_handle: "college-football-tickets",
        name: "College football",
        search_tags: ["college football tickets"],
        img: null,
    },
    {
        _id: "football-tickets",
        parent_id: ["tickets"],
        order_num: 3,
        url_handle: "football-tickets",
        name: "Football",
        search_tags: ["football tickets"],
        img: null,
    },
    {
        _id: "basketball-tickets",
        parent_id: ["tickets"],
        order_num: 4,
        url_handle: "basketball-tickets",
        name: "Basketball",
        search_tags: ["basketball tickets"],
        img: null,
    },
    {
        _id: "hockey-tickets",
        parent_id: ["tickets"],
        order_num: 5,
        url_handle: "hockey-tickets",
        name: "Hockey",
        search_tags: ["hockey tickets"],
        img: null,
    },
    {
        _id: "tennis-tickets",
        parent_id: ["tickets"],
        order_num: 6,
        url_handle: "tennis-tickets",
        name: "Tennis",
        search_tags: ["tennis tickets"],
        img: null,
    },
    // Apparel
    {
        _id: "clothing",
        parent_id: null,
        featured: true,
        order_num: 2,
        url_handle: "clothing",
        name: "Clothing",
        search_tags: ["clothing", "clothing", "shoes", "jewelry", "watches", "sunglasses"],
        img: clothing_img,
    },
    {
        _id: "tops",
        parent_id: ["clothing"],
        order_num: 1,
        url_handle: "tops",
        name: "Tops",
        search_tags: ["tops"],
        img: null,
    },
    {
        _id: "bottoms",
        parent_id: ["clothing"],
        order_num: 2,
        url_handle: "bottoms",
        name: "Bottoms",
        search_tags: ["bottoms"],
        img: null,
    },
    {
        _id: "shoes",
        parent_id: ["clothing"],
        order_num: 3,
        url_handle: "shoes",
        name: "Shoes",
        search_tags: ["shoes"],
        img: null,
    },
    {
        _id: "jewelry",
        parent_id: ["clothing"],
        order_num: 4,
        url_handle: "jewelry",
        name: "Jewelry",
        search_tags: ["jewelry"],
        img: null,
    },
    {
        _id: "watches",
        parent_id: ["clothing"],
        order_num: 5,
        url_handle: "watches",
        name: "Watches",
        search_tags: ["watches"],
        img: null,
    },
    {
        _id: "sunglasses",
        parent_id: ["clothing"],
        order_num: 6,
        url_handle: "sunglasses",
        name: "Sunglasses",
        search_tags: ["sunglasses"],
        img: null,
    },
    // Electronics
    {
        _id: "electronics",
        parent_id: null,
        featured: true,
        order_num: 3,
        url_handle: "electronics",
        name: "Electronics",
        search_tags: ["electronics", "computers", "laptops", "pcs", "tablets", "monitors", "game-systems", "playstation", "nintendo", "xbox", "smart-home", "tvs", "cell-phones", "headphones", "speakers", "cameras", "printers", "vr-headsets", "smart-watches"],
        img: electronics_img,
    },
    // - Computers
    {
        _id: "computers",
        parent_id: ["electronics"],
        order_num: 1,
        url_handle: "computers",
        name: "Computers",
        search_tags: ["computers", "laptops", "pcs", "tablets", "monitors"],
        img: null,
    },
    {
        _id: "laptops",
        parent_id: ["computers"],
        order_num: 1,
        url_handle: "laptops",
        name: "Laptops",
        search_tags: ["laptops"],
        img: null,
    },
    {
        _id: "pcs",
        parent_id: ["computers"],
        order_num: 2,
        url_handle: "pcs",
        name: "PCs",
        search_tags: ["pcs"],
        img: null,
    },
    {
        _id: "tablets",
        parent_id: ["computers"],
        order_num: 3,
        url_handle: "tablets",
        name: "Tablets",
        search_tags: ["tablets"],
        img: null,
    },
    {
        _id: "monitors",
        parent_id: ["computers"],
        order_num: 4,
        url_handle: "monitors",
        name: "Monitors",
        search_tags: ["monitors"],
        img: null,
    },
    // - END:Computers
    // - Game systems
    {
        _id: "game-systems",
        parent_id: ["electronics"],
        order_num: 2,
        url_handle: "game-systems",
        name: "Game systems",
        search_tags: ["game-systems", "playstation", "nintendo", "xbox"],
        img: null,
    },
    {
        _id: "playstation",
        parent_id: ["game-systems"],
        order_num: 1,
        url_handle: "playstation",
        name: "Playstation",
        search_tags: ["playstation"],
        img: null,
    },
    {
        _id: "nintendo",
        parent_id: ["game-systems"],
        order_num: 2,
        url_handle: "nintendo",
        name: "Nintendo",
        search_tags: ["nintendo"],
        img: null,
    },
    {
        _id: "xbox",
        parent_id: ["game-systems"],
        order_num: 3,
        url_handle: "xbox",
        name: "Xbox",
        search_tags: ["xbox"],
        img: null,
    },
    // - END: Game systems
    {
        _id: "smart-home",
        parent_id: ["electronics"],
        order_num: 3,
        url_handle: "smart-home",
        name: "Smart home",
        search_tags: ["smart-home"],
        img: null,
    },
    {
        _id: "tvs",
        parent_id: ["electronics"],
        order_num: 4,
        url_handle: "tvs",
        name: "Tvs",
        search_tags: ["tvs"],
        img: null,
    },
    {
        _id: "cell-phones",
        parent_id: ["electronics"],
        order_num: 5,
        url_handle: "cell-phones",
        name: "Cell phones",
        search_tags: ["cell-phones"],
        img: null,
    },
    {
        _id: "headphones",
        parent_id: ["electronics"],
        order_num: 6,
        url_handle: "headphones",
        name: "Headphones",
        search_tags: ["headphones"],
        img: null,
    },
    {
        _id: "speakers",
        parent_id: ["electronics"],
        order_num: 7,
        url_handle: "speakers",
        name: "Speakers",
        search_tags: ["speakers"],
        img: null,
    },
    {
        _id: "cameras",
        parent_id: ["electronics"],
        order_num: 8,
        url_handle: "cameras",
        name: "Cameras",
        search_tags: ["cameras"],
        img: null,
    },
    {
        _id: "printers",
        parent_id: ["electronics"],
        order_num: 9,
        url_handle: "printers",
        name: "Printers",
        search_tags: ["printers"],
        img: null,
    },
    {
        _id: "vr-headsets",
        parent_id: ["electronics"],
        order_num: 10,
        url_handle: "vr-headsets",
        name: "Vr headsets",
        search_tags: ["vr-headsets"],
        img: null,
    },
    {
        _id: "smart-watches",
        parent_id: ["electronics"],
        order_num: 11,
        url_handle: "smart-watches",
        name: "Smart watches",
        search_tags: ["smart-watches"],
        img: null,
    },
    // Collectibles
    {
        _id: "collectibles",
        parent_id: null,
        featured: true,
        order_num: 4,
        url_handle: "collectibles",
        name: "Collectibles",
        search_tags: ["collectibles", "trading-cards", "action-figures", "dolls", "coins", "sports-memorabilia", "comic-books", "music-instruments", "record-players"],
        img: collectibles_img,
    },
    {
        _id: "trading-cards",
        parent_id: ["collectibles"],
        order_num: 1,
        url_handle: "trading-cards",
        name: "Trading cards",
        search_tags: ["trading-cards"],
        img: null,
    },
    {
        _id: "action-figures",
        parent_id: ["collectibles"],
        order_num: 2,
        url_handle: "action-figures",
        name: "Action figures",
        search_tags: ["action-figures"],
        img: null,
    },
    {
        _id: "dolls",
        parent_id: ["collectibles"],
        order_num: 3,
        url_handle: "dolls",
        name: "Dolls",
        search_tags: ["dolls"],
        img: null,
    },
    {
        _id: "coins",
        parent_id: ["collectibles"],
        order_num: 4,
        url_handle: "coins",
        name: "Coins",
        search_tags: ["coins"],
        img: null,
    },
    {
        _id: "sports-memorabilia",
        parent_id: ["collectibles"],
        order_num: 5,
        url_handle: "sports-memorabilia",
        name: "Sports memorabilia",
        search_tags: ["sports-memorabilia"],
        img: null,
    },
    {
        _id: "comic-books",
        parent_id: ["collectibles"],
        order_num: 6,
        url_handle: "comic-books",
        name: "Comic books",
        search_tags: ["comic-books"],
        img: null,
    },
    {
        _id: "music-instruments",
        parent_id: ["collectibles"],
        order_num: 7,
        url_handle: "music-instruments",
        name: "Music instruments",
        search_tags: ["music-instruments"],
        img: null,
    },
    {
        _id: "record-players",
        parent_id: ["collectibles"],
        order_num: 8,
        url_handle: "record-players",
        name: "Record players",
        search_tags: ["record-players"],
        img: null,
    },
    // Furniture
    {
        _id: "furniture",
        parent_id: null,
        featured: true,
        order_num: 5,
        url_handle: "furniture",
        name: "Furniture",
        search_tags: ["furniture", "desk", "bed-frames", "mattresses", "kitchen-supplies", "home-decor", "kids-room", "vacuums", "luggage", "bathroom-supplies"],
        img: furniture_img,
    },
    {
        _id: "desk",
        parent_id: ["furniture"],
        order_num: 1,
        url_handle: "desk",
        name: "Desk",
        search_tags: ["desk"],
        img: null,
    },
    {
        _id: "bed-frames",
        parent_id: ["furniture"],
        order_num: 2,
        url_handle: "bed-frames",
        name: "Bed frames",
        search_tags: ["bed-frames"],
        img: null,
    },
    {
        _id: "mattresses",
        parent_id: ["furniture"],
        order_num: 3,
        url_handle: "mattresses",
        name: "Mattresses",
        search_tags: ["mattresses"],
        img: null,
    },
    {
        _id: "kitchen-supplies",
        parent_id: ["furniture"],
        order_num: 4,
        url_handle: "kitchen-supplies",
        name: "Kitchen supplies",
        search_tags: ["kitchen-supplies"],
        img: null,
    },
    {
        _id: "home-decor",
        parent_id: ["furniture"],
        order_num: 5,
        url_handle: "home-decor",
        name: "Home decor",
        search_tags: ["home-decor"],
        img: null,
    },
    {
        _id: "kids-room",
        parent_id: ["furniture"],
        order_num: 6,
        url_handle: "kids-room",
        name: "Kids room",
        search_tags: ["kids-room"],
        img: null,
    },
    {
        _id: "vacuums",
        parent_id: ["furniture"],
        order_num: 7,
        url_handle: "vacuums",
        name: "Vacuums",
        search_tags: ["vacuums"],
        img: null,
    },
    {
        _id: "luggage",
        parent_id: ["furniture"],
        order_num: 8,
        url_handle: "luggage",
        name: "Luggage",
        search_tags: ["luggage"],
        img: null,
    },
    {
        _id: "bathroom-supplies",
        parent_id: ["furniture"],
        order_num: 9,
        url_handle: "bathroom-supplies",
        name: "Bathroom supplies",
        search_tags: ["bathroom-supplies"],
        img: null,
    },
    // Vehicles
    {
        _id: "vehicles",
        parent_id: null,
        featured: true,
        order_num: 6,
        url_handle: "vehicles",
        name: "Vehicles",
        search_tags: ["vehicles"],
        img: vehicles_img,
    },
    // Auto parts
    {
        _id: "auto-parts",
        parent_id: null,
        featured: true,
        order_num: 7,
        url_handle: "auto-parts",
        name: "Auto parts",
        search_tags: ["auto-parts", "tires", "car-batteries", "car-oil", "auto-electronics", "auto-tools-equipment"],
        img: auto_parts_img,
    },
    {
        _id: "tires",
        parent_id: ["auto-parts"],
        order_num: 1,
        url_handle: "tires",
        name: "Tires",
        search_tags: ["tires"],
        img: null,
    },
    {
        _id: "car-batteries",
        parent_id: ["auto-parts"],
        order_num: 2,
        url_handle: "car-batteries",
        name: "Car batteries",
        search_tags: ["car-batteries"],
        img: null,
    },
    {
        _id: "car-oil",
        parent_id: ["auto-parts"],
        order_num: 3,
        url_handle: "car-oil",
        name: "Car oil",
        search_tags: ["car-oil"],
        img: null,
    },
    {
        _id: "auto-electronics",
        parent_id: ["auto-parts"],
        order_num: 4,
        url_handle: "auto-electronics",
        name: "Auto electronics",
        search_tags: ["auto-electronics"],
        img: null,
    },
    {
        _id: "auto-tools-equipment",
        parent_id: ["auto-parts"],
        order_num: 5,
        url_handle: "auto-tools-equipment",
        name: "Auto tools & equipment",
        search_tags: ["auto-tools-equipment"],
        img: null,
    },
    // School supplies
    {
        _id: "school-supplies",
        parent_id: null,
        featured: true,
        order_num: 8,
        url_handle: "school-supplies",
        name: "School supplies",
        search_tags: ["school-supplies", "textbooks", "calculators", "iclickers"],
        img: school_supplies_img,
    },
    {
        _id: "textbooks",
        parent_id: ["school-supplies"],
        order_num: 1,
        url_handle: "textbooks",
        name: "Textbooks",
        search_tags: ["textbooks"],
        img: null,
    },
    {
        _id: "calculators",
        parent_id: ["calculators"],
        order_num: 2,
        url_handle: "calculators",
        name: "Calculators",
        search_tags: ["calculators"],
        img: null,
    },
    {
        _id: "iclickers",
        parent_id: ["school-supplies"],
        order_num: 3,
        url_handle: "iclickers",
        name: "iClickers",
        search_tags: ["iclickers"],
        img: null,
    },
    // Art supplies
    {
        _id: "art-supplies",
        parent_id: null,
        featured: true,
        order_num: 9,
        url_handle: "art-supplies",
        name: "Art supplies",
        search_tags: ["art-supplies"],
        img: art_supplies_img,
    },
    // Entertainment
    {
        _id: "enterainment",
        parent_id: null,
        featured: true,
        order_num: 10,
        url_handle: "enterainment",
        name: "Enterainment",
        search_tags: ["enterainment", "video-games", "movies", "comic-books", "books", "music"],
        img: entertainment_img,
    },
    {
        _id: "video-games",
        parent_id: ["enterainment"],
        order_num: 1,
        url_handle: "video-games",
        name: "Video Games",
        search_tags: ["video-games"],
        img: null,
    },
    {
        _id: "movies",
        parent_id: ["enterainment"],
        order_num: 2,
        url_handle: "movies",
        name: "Movies",
        search_tags: ["movies"],
        img: null,
    },
    {
        _id: "comic-books",
        parent_id: ["enterainment"],
        order_num: 3,
        url_handle: "comic-books",
        name: "Comic books",
        search_tags: ["comic-books"],
        img: null,
    },
    {
        _id: "books",
        parent_id: ["enterainment"],
        order_num: 4,
        url_handle: "books",
        name: "Books",
        search_tags: ["books"],
        img: null,
    },
    {
        _id: "music",
        parent_id: ["enterainment"],
        order_num: 5,
        url_handle: "music",
        name: "Music",
        search_tags: ["music"],
        img: null,
    },
    // Health & wellness
    {
        _id: "health-wellness",
        parent_id: null,
        featured: true,
        order_num: 11,
        url_handle: "health-wellness",
        name: "Health & wellness",
        search_tags: ["health-wellness", "feminine-care", "vitamins", "pain-management", "protein-supplements", "allergy-care", "cough-cold-flu", "first-aid", "eye-care"],
        img: health_wellness_img,
    },
    {
        _id: "feminine-care",
        parent_id: ["health-wellness"],
        order_num: 1,
        url_handle: "feminine-care",
        name: "Feminine care",
        search_tags: ["feminine-care"],
        img: null,
    },
    {
        _id: "vitamins",
        parent_id: ["health-wellness"],
        order_num: 2,
        url_handle: "vitamins",
        name: "Vitamins",
        search_tags: ["vitamins"],
        img: null,
    },
    {
        _id: "pain-management",
        parent_id: ["health-wellness"],
        order_num: 3,
        url_handle: "pain-management",
        name: "Pain management",
        search_tags: ["pain-management"],
        img: null,
    },
    {
        _id: "protein-supplements",
        parent_id: ["health-wellness"],
        order_num: 4,
        url_handle: "protein-supplements",
        name: "Protein & supplements",
        search_tags: ["protein-supplements"],
        img: null,
    },
    {
        _id: "allergy-care",
        parent_id: ["health-wellness"],
        order_num: 5,
        url_handle: "allergy-care",
        name: "Allergy care",
        search_tags: ["allergy-care"],
        img: null,
    },
    {
        _id: "cough-cold-flu",
        parent_id: ["health-wellness"],
        order_num: 6,
        url_handle: "cough-cold-flu",
        name: "Cough, cold & flu",
        search_tags: ["cough-cold-flu"],
        img: null,
    },
    {
        _id: "first-aid",
        parent_id: ["health-wellness"],
        order_num: 7,
        url_handle: "first-aid",
        name: "First aid",
        search_tags: ["first-aid"],
        img: null,
    },
    {
        _id: "eye-care",
        parent_id: ["health-wellness"],
        order_num: 8,
        url_handle: "eye-care",
        name: "Eye care",
        search_tags: ["eye-care"],
        img: null,
    },
    // Baby & kids
    {
        _id: "baby-kids",
        parent_id: null,
        featured: true,
        order_num: 12,
        url_handle: "baby-kids",
        name: "Baby & kids",
        search_tags: ["baby-kids", "diapers", "baby-supplies", "baby-food", "kids-clothing", "strollers"],
        img: baby_kids_img,
    },
    {
        _id: "diapers",
        parent_id: ["baby-kids"],
        order_num: 1,
        url_handle: "diapers",
        name: "Diapers",
        search_tags: ["diapers"],
        img: null,
    },
    {
        _id: "baby-supplies",
        parent_id: ["baby-kids"],
        order_num: 2,
        url_handle: "baby-supplies",
        name: "Baby supplies",
        search_tags: ["baby-supplies"],
        img: null,
    },
    {
        _id: "baby-food",
        parent_id: ["baby-kids"],
        order_num: 3,
        url_handle: "baby-food",
        name: "Baby food",
        search_tags: ["baby-food"],
        img: null,
    },
    {
        _id: "kids-clothing",
        parent_id: ["baby-kids"],
        order_num: 4,
        url_handle: "kids-clothing",
        name: "Kids clothing",
        search_tags: ["kids-clothing"],
        img: null,
    },
    {
        _id: "strollers",
        parent_id: ["baby-kids"],
        order_num: 5,
        url_handle: "strollers",
        name: "Strollers",
        search_tags: ["strollers"],
        img: null,
    },
    // Personal care
    {
        _id: "personal-care",
        parent_id: null,
        featured: true,
        order_num: 13,
        url_handle: "personal-care",
        name: "Personal care",
        search_tags: ["personal-care", "hair-care", "shampoo", "conditioners", "hair-accessories", "skin-care", "nail-care", "deodorant", "shave", "oral-care", "sex-tools"],
        img: personal_care_img,
    },
    // - Hair care
    {
        _id: "hair-care",
        parent_id: ["personal-care"],
        order_num: 1,
        url_handle: "hair-care",
        name: "Hair care",
        search_tags: ["hair-care", "shampoo", "conditioners", "hair-accessories"],
        img: null,
    },
    {
        _id: "shampoo",
        parent_id: ["hair-care"],
        order_num: 1,
        url_handle: "shampoo",
        name: "Shampoo",
        search_tags: ["shampoo"],
        img: null,
    },
    {
        _id: "conditioners",
        parent_id: ["hair-care"],
        order_num: 2,
        url_handle: "conditioners",
        name: "Conditioners",
        search_tags: ["conditioners"],
        img: null,
    },
    {
        _id: "hair-accessories",
        parent_id: ["hair-care"],
        order_num: 3,
        url_handle: "hair-accessories",
        name: "Hair accessories",
        search_tags: ["hair-accessories"],
        img: null,
    },
    // - END: Hair care
    {
        _id: "skin-care",
        parent_id: ["personal-care"],
        order_num: 2,
        url_handle: "skin-care",
        name: "Skin care",
        search_tags: ["skin-care"],
        img: null,
    },
    {
        _id: "nail-care",
        parent_id: ["personal-care"],
        order_num: 3,
        url_handle: "nail-care",
        name: "Nail care",
        search_tags: ["nail-care"],
        img: null,
    },
    {
        _id: "deodorant",
        parent_id: ["personal-care"],
        order_num: 4,
        url_handle: "deodorant",
        name: "Deodorant",
        search_tags: ["deodorant"],
        img: null,
    },
    {
        _id: "shave",
        parent_id: ["personal-care"],
        order_num: 5,
        url_handle: "shave",
        name: "Shave",
        search_tags: ["shave"],
        img: null,
    },
    {
        _id: "oral-care",
        parent_id: ["personal-care"],
        order_num: 6,
        url_handle: "oral-care",
        name: "Oral care",
        search_tags: ["oral-care"],
        img: null,
    },
    {
        _id: "sex-tools",
        parent_id: ["personal-care"],
        order_num: 7,
        url_handle: "sex-tools",
        name: "Sex tools",
        search_tags: ["sex-tools"],
        img: null,
    },
    // Beauty
    {
        _id: "beauty",
        parent_id: null,
        featured: true,
        order_num: 14,
        url_handle: "beauty",
        name: "Beauty",
        search_tags: ["beauty", "makeup", "fragrance", "beauty-tools"],
        img: beauty_img,
    },
    {
        _id: "makeup",
        parent_id: ["beauty"],
        order_num: 1,
        url_handle: "makeup",
        name: "Makeup",
        search_tags: ["makeup"],
        img: null,
    },
    {
        _id: "fragrance",
        parent_id: ["beauty"],
        order_num: 2,
        url_handle: "fragrance",
        name: "Fragrance",
        search_tags: ["fragrance"],
        img: null,
    },
    {
        _id: "beauty-tools",
        parent_id: ["beauty"],
        order_num: 3,
        url_handle: "beauty-tools",
        name: "Beauty tools",
        search_tags: ["beauty-tools"],
        img: null,
    },
    // Pets
    {
        _id: "pets",
        parent_id: null,
        featured: true,
        order_num: 15,
        url_handle: "pets",
        name: "Pets",
        search_tags: ["pets", "dog-supplies", "dog-toys", "dog-food", "cat-supplies", "cat-toys", "cat-food", "fish-supplies"],
        img: pets_img,
    },
    { 
        _id: "dog-supplies", 
        parent_id: ["pets"], 
        order_num: 1, 
        url_handle: "dog-supplies", 
        name: "Dog supplies", 
        search_tags: ["dog-supplies"], 
        img: null 
    },
    { 
        _id: "dog-toys", 
        parent_id: ["pets"], 
        order_num: 2, 
        url_handle: "dog-toys", 
        name: "Dog toys", 
        search_tags: ["dog-toys"], 
        img: null 
    },
    { 
        _id: "dog-food", 
        parent_id: ["pets"], 
        order_num: 3, 
        url_handle: "dog-food", 
        name: "Dog food", 
        search_tags: ["dog-food"], 
        img: null 
    },
    { 
        _id: "cat-supplies", 
        parent_id: ["pets"], 
        order_num: 4, 
        url_handle: "cat-supplies", 
        name: "Cat supplies", 
        search_tags: ["cat-supplies"], 
        img: null 
    },
    { 
        _id: "cat-toys", 
        parent_id: ["pets"], 
        order_num: 5, 
        url_handle: "cat-toys", 
        name: "Cat toys", 
        search_tags: ["cat-toys"], 
        img: null 
    },
    { 
        _id: "cat-food", 
        parent_id: ["pets"], 
        order_num: 6, 
        url_handle: "cat-food", 
        name: "Cat food", 
        search_tags: ["cat-food"], 
        img: null 
    },
    { 
        _id: "fish-supplies", 
        parent_id: ["pets"], 
        order_num: 7, 
        url_handle: "fish-supplies", 
        name: "Fish supplies", 
        search_tags: ["fish-supplies"], 
        img: null 
    },
    // Sports
    {
        _id: "sports",
        parent_id: null,
        featured: true,
        order_num: 16,
        url_handle: "sports",
        name: "Sports",
        search_tags: ["sports", "bikes", "skateboards", "boating", "hunting", "fishing", "camping", "fitness", "outdoor-entertainment"],
        img: sports_img,
    },
    {
        _id: "bikes",
        parent_id: ["sports"],
        order_num: 1,
        url_handle: "bikes",
        name: "Bikes",
        search_tags: ["bikes"],
        img: null,
    },
    {
        _id: "skateboards",
        parent_id: ["sports"],
        order_num: 2,
        url_handle: "skateboards",
        name: "Skateboards",
        search_tags: ["skateboards"],
        img: null,
    },
    {
        _id: "boating",
        parent_id: ["sports"],
        order_num: 3,
        url_handle: "boating",
        name: "Boating",
        search_tags: ["boating"],
        img: null,
    },
    {
        _id: "hunting",
        parent_id: ["sports"],
        order_num: 4,
        url_handle: "hunting",
        name: "Hunting",
        search_tags: ["hunting"],
        img: null,
    },
    {
        _id: "fishing",
        parent_id: ["sports"],
        order_num: 5,
        url_handle: "fishing",
        name: "Fishing",
        search_tags: ["fishing"],
        img: null,
    },
    {
        _id: "camping",
        parent_id: ["sports"],
        order_num: 6,
        url_handle: "camping",
        name: "Camping",
        search_tags: ["camping"],
        img: null,
    },
    {
        _id: "fitness",
        parent_id: ["sports"],
        order_num: 7,
        url_handle: "fitness",
        name: "Fitness",
        search_tags: ["fitness"],
        img: null,
    },
    {
        _id: "outdoor-entertainment",
        parent_id: ["sports"],
        order_num: 8,
        url_handle: "outdoor-entertainment",
        name: "Outdoor entertainment",
        search_tags: ["outdoor-entertainment"],
        img: null,
    },
    // Gardening
    {
        _id: "gardening",
        parent_id: null,
        featured: true,
        order_num: 17,
        url_handle: "gardening",
        name: "Gardening",
        search_tags: ["gardening"],
        img: gardening_img,
    },
    // Lawn care
    {
        _id: "lawn-care",
        parent_id: null,
        featured: true,
        order_num: 18,
        url_handle: "lawn-care",
        name: "Lawn Care",
        search_tags: ["lawn-care"],
        img: lawn_care_img,
    },
    // Seasonal
    {
        _id: "seasonal",
        parent_id: null,
        featured: true,
        order_num: 19,
        url_handle: "seasonal",
        name: "Seasonal",
        search_tags: ["seasonal", "halloween", "christmas"],
        img: seasonal_img,
    },
    {
        _id: "halloween",
        parent_id: ["seasonal"],
        order_num: 1,
        url_handle: "halloween",
        name: "Halloween",
        search_tags: ["halloween"],
        img: null,
    },
    {
        _id: "christmas",
        parent_id: ["seasonal"],
        order_num: 2,
        url_handle: "christmas",
        name: "Christmas",
        search_tags: ["christmas"],
        img: null,
    },
];